import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { formatMoney } from 'shared/util/formatting';
import type { Money } from 'shared/util/money';
import { WELCOME_TO_NEW_FHH_ON_HELPCENTER } from '@/constants';

type ServiceFeeDetailProps = {
    money: Money;
};

export const ServiceFeeDetail = ({ money }: ServiceFeeDetailProps) => {
    const [showInfo, setShowInfo] = useState(false);

    return (
        <>
            <div className="flex justify-between my-8">
                <Button link className="s-text text-14 text-left" onClick={() => setShowInfo(!showInfo)}>
                    FINN.no tjenestegebyr
                </Button>
                <data className="text-14" value={money.value}>
                    {formatMoney(money, 0)}
                </data>
            </div>
            {showInfo && (
                <p className="text-left text-12 s-text-subtle pb-10">
                    Tjenestegebyret gjør at vi kan fortsette å vedlikeholde og utvikle tjenestene våre.
                    <Button
                        small
                        link
                        href={`${WELCOME_TO_NEW_FHH_ON_HELPCENTER}#FINNs-tjenestegebyr`}
                        target="_blank"
                        rel="noreferrer"
                        className="ml-4">
                        Les mer om gebyret.
                    </Button>
                </p>
            )}
        </>
    );
};
